import React, { useCallback, useEffect, useState } from "react"
import Spinner from "./Spinner"

type TSpinnerWithSearching<T, C> = {
  children: React.ReactNode
  searchFunction: (userInfo: C) => Promise<T>
  searchStart: boolean
  condition: C
}

const SpinnerWithSearching = <T, C>({
  searchFunction,
  searchStart,
  condition,
  ...props
}: TSpinnerWithSearching<T, C>) => {
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  const search = useCallback(async () => {
    await searchFunction(condition)
    setIsSpinnerShow(false)
  }, [searchFunction, condition])

  // 外部フラグの取込
  // ON時のみスピナー起動し、起動と同時にサーチ開始
  useEffect(() => {
    if (!searchStart) return
    setIsSpinnerShow(true)
  }, [searchStart])

  useEffect(() => {
    // スピナーがONになっていれば検索開始
    if (!isSpinnerShow) return
    search()
  }, [isSpinnerShow, search])

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        minHeight: "10rem",
        position: "relative",
      }}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      {!isSpinnerShow && props.children}
    </div>
  )
}

export default SpinnerWithSearching
